import { UserRole } from "../Enums/companyStatus";
import { hasRole } from "./authHelpers";

const STORAGE_KEY = "document_crafting_workspace_id";
const HEADER = "X-Document-Crafting-Workspace";

/** The workspace a platform admin chose for Document Crafting, or null for
 * their own one. */
export const getDocumentCraftingWorkspaceId = (): number | null => {
  const stored = localStorage.getItem(STORAGE_KEY);
  const workspaceId = stored ? Number(stored) : NaN;
  return Number.isInteger(workspaceId) && workspaceId > 0 ? workspaceId : null;
};

/** null goes back to the admin's own workspace. */
export const setDocumentCraftingWorkspaceId = (workspaceId: number | null) => {
  if (workspaceId === null) localStorage.removeItem(STORAGE_KEY);
  else localStorage.setItem(STORAGE_KEY, String(workspaceId));
};

// Admins may act on another workspace (chosen in the module settings); the
// header is optional for them and ignored for everyone else, who always work
// in the workspace of their account.
export const documentCraftingHeaders = (): Record<string, string> => {
  const workspaceId = getDocumentCraftingWorkspaceId();
  if (!hasRole(UserRole.ADMIN) || workspaceId === null) return {};
  return { [HEADER]: String(workspaceId) };
};
